var messagesAction;

messagesAction = function() {
  if ($('.messages-aside').length === 0) {
    return;
  }

  let $this;

  const firstDialog = $('.user-item:first')[0]
  const $preload = $('.messages-preload');

  let dialog = null;
  let member = null;
  if (firstDialog) {
    dialog = firstDialog.getAttribute("data-dialog-id");
    member = firstDialog.getAttribute("data-id");
  }

  const initScrollList = () => {
    const $list = $('.messages-list');
    if($list.length) {
      $list.scrollTop($list[0].scrollHeight);
    }
  }

  function selectDialog($this, dialogMemberId, dialogId) {
    return $.get(Routes.dialog_member_path(dialogMemberId), function(data) {
      $('.messages-list').replaceWith(data.messages);
      $('#new-dialog-message-form').attr('action', Routes.dialog_messages_path(dialogId));
      $('.user-item.current').removeClass('current');
      $('.messages-body__OpponentName').text(data.name)
      $('.messages-body__OpponentOnline').text(data.state)
      $this.addClass('current');
      $this.find('.unread-count').fadeOut(300);
      setTimeout(() => $preload.addClass('messages-preload--hidden'), 500)
      setTimeout(() => initScrollList())
      $('.message-controls:visible').fadeOut(200);
    })
  }

  const initPreload = () => {
    if($preload.hasClass('messages-preload--hidden')) {
      $preload.removeClass('messages-preload--hidden')
    } else {
      $preload.addClass('messages-preload--hidden')
    }
  }

  if (dialog && member) {
    $this = $('*[data-dialog-id=' + dialog + ']');
    // selectDialog($this, member, dialog);
    setTimeout(() => initPreload())
    $('#message_text').focus();
  }

  $('.js-dialog-member-action').on('click',function() {
    var method, url;
    $this = $(this);
    url = $this.data('url');
    method = $this.data('method');
    $.ajax({
      url: url,
      type: method,
      headers: {"X-CSRF-Token": $('meta[name=csrf-token]').attr('content')},
      success: function() {
        var $newUserItem;
        $this.closest('.user-item').remove();
        $newUserItem = $('.user-list').find('.user-item:first');
        if ($newUserItem.length > 0) {
          return $newUserItem.click();
        } else {
          $('.messages-section').addClass('empty');
          return $('.messages-body').replaceWith('<div class="messages-empty">' + I18n.t('dialogs.no_messages') + '</div>');
        }
      }
    });
    return false;
  });

  $('body').on('click', '.user-item', function() {
    $preload.removeClass('messages-preload--hidden')
    selectDialog($(this), this.getAttribute("data-id"), this.getAttribute("data-dialog-id")).then( () => {
      if (window.innerWidth < 767) {
        $('.messages-aside').css('display', 'none');
        $('.messages-body').css('display', 'flex');
      }
      }
    )
    if (!$(this).hasClass('current')) {
      $('.user-item.current').removeClass('current');
      $(this).addClass('current');
      $(this).find('.unread-count').fadeOut(300);
      $('.message-controls:visible').fadeOut(200);
    }
    return false;
  });
  $('body').on('click', '.menu-button', function() {
    $('.message-controls:visible').fadeOut(200);
    setTimeout(() => {
      if ($(this).parents('.user-item').find('.message-controls').css('display') === 'flex') {
        $(this).parents('.user-item').find('.message-controls').fadeOut(400);
      } else {
        $(this).parents('.user-item').find('.message-controls').fadeIn(200);
      }
      if ($(this).parents('.user-item').find('.message-controls').offset().top < 100) {
        $(this).parents('.user-item').find('.message-controls').addClass('top');
      }
      if ($(this).parents('.user-item').find('.message-controls').offset().top >= $(window).height() - 250) {
        $(this).parents('.user-item').find('.message-controls').addClass('bottom');
      }
    }, 0)
    return false;
  });

  $('body').on('click', '*:not(.menu-button,.message-controls)', function() {
    $('.message-controls:visible').fadeOut(200);
    return true;
  });

  if ($('.message-input').val().length === 0) {
    $('.message-form__button').addClass('disabled');
  }
  return $('body').on('input', '.message-input', function() {
    if ($(this).val().length === 0) {
      $('.message-form__button').addClass('disabled').attr('disabled', 'disabled');
    } else {
      $('.message-form__button').removeClass('disabled').removeAttr('disabled');
    }
    return true;
  });
};

export {
  messagesAction
}
